import { Routing } from '@/constants';
export const isEnrichPage = (pathname) => pathname.startsWith(Routing.ENRICH_PATH);
